import React from 'react';
import { User, UserGoal } from 'types';
import StartYearEvaluationForm from './StartYearEvaluationForm';
import MidYearEvaluationForm from './MidYearEvaluationForm';
import EndYearEvaluationForm from './EndYearEvaluationForm';

const EvaluationFormTemplate: React.FC<{
  employee: User;
  initialRows?: UserGoal[];
  period: number;
}> = ({ employee, initialRows, period }) => {
  return (
    <div>
      {period === 1 && <StartYearEvaluationForm initialRows={initialRows} employee={employee} />}
      {period === 2 && (
        <MidYearEvaluationForm initialRows={initialRows ?? []} employee={employee} />
      )}
      {period === 3 && (
        <EndYearEvaluationForm initialRows={initialRows ?? []} employee={employee} />
      )}
    </div>
  );
};

export default EvaluationFormTemplate;
